import { HttpStatusCode } from "axios"
import { UsageInformation } from "src/model/payment"
import { StatusSubscription } from "src/utils/constants/enum"

export const checkExistSubscription = (data: UsageInformation) => {
  return data?.status_code === HttpStatusCode.Ok && data.data.status === StatusSubscription.ACTIVE
}